'use es6';

import PropTypes from 'prop-types';
import { NavMarker } from 'react-rhumb';
import { isSucceeded, isFailed } from '../../constants/asyncStatuses';
import { jsx as _jsx } from "react/jsx-runtime";
const asyncStatePropType = PropTypes.shape({
  data: PropTypes.object,
  status: PropTypes.string
}).isRequired;
const Checker = ({
  startOpen,
  widgetDataAsyncData,
  threadsAsyncData
}) => {
  const requestsToCheck = [widgetDataAsyncData];
  if (startOpen) {
    requestsToCheck.push(threadsAsyncData);
  }
  const anyFailed = requestsToCheck.some(asyncData => isFailed(asyncData));
  const allSucceeded = requestsToCheck.every(asyncData => isSucceeded(asyncData));
  if (anyFailed) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "VISITOR_ERROR"
    });
  } else if (allSucceeded) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "VISITOR_SUCCESS"
    });
  } else {
    return null;
  }
};
Checker.propTypes = {
  startOpen: PropTypes.bool,
  threadsAsyncData: asyncStatePropType,
  widgetDataAsyncData: asyncStatePropType
};
Checker.displayName = 'Checker';
export default Checker;